(function() {
  let swiper_carousel = null;

  const breakpoint = window.matchMedia('(min-width: 768px)');

  const swiperContainer = document.querySelector('.swiper_carousel');
  const carouselWrapper = document.querySelector('.mobile-carousel');

  if (!swiperContainer || !carouselWrapper) {
    // console.log('Swiper elements not found');
    return;
  }

  function initializeSwiper() {   
    if (swiper_carousel) {
      return;
    }

    swiper_carousel = new Swiper(".swiper_carousel", {
      slidesPerView: 1,
      slidesPerGroup: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      spaceBetween: 2,
    });
  }

  function destroySwiper() {   
    if (swiper_carousel) {
      swiper_carousel.destroy(true, true);
      swiper_carousel = null;
    }
  }

  function handleBreakpoint(matches) {
    if (matches) {
      carouselWrapper.classList.add('flexible-layout', 'flexible-layout--variable-columns');
      destroySwiper();
    } else {
      carouselWrapper.classList.remove('flexible-layout', 'flexible-layout--variable-columns');
      initializeSwiper();
    }
  }

  handleBreakpoint(breakpoint.matches);

  breakpoint.addEventListener('change', (event) => {
    handleBreakpoint(event.matches);
  });

})();